import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { imageUrl } from '../Baseurl';
import { Link } from 'react-router-dom';

// Custom Arrow Button
const ArrowButton = ({ className, style, onClick, icon }) => {
  return (
    <button
      className={className}
      style={{
        ...style,
        display: 'block',
        background: 'transparent',
        border: 'none',
        color: '#fff',
        backgroundColor: "#00000033"
      }}
      onClick={onClick}
    >
      {icon}
    </button>
  );
};

const CategorySlider = ({ maincategories }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000); // Simulated loading delay
    return () => clearTimeout(timer);
  }, []);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    prevArrow: <ArrowButton className="slick-prev" icon="❮" />,
    nextArrow: <ArrowButton className="slick-next" icon="❯" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  };

  const maincategoriesItem = Array.isArray(maincategories) ? maincategories : [];

  return (
    <div className="category-slider text-center">
      <Slider {...settings}>
        {loading
          ? // Skeleton loader
            [...Array(6)].map((_, index) => (
              <div key={index} className="category-item">
                <div
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    margin: "auto",
                    background: "#333",
                    opacity: 0.3,
                    animation: "pulse 1.5s infinite"
                  }}
                ></div>
                <p style={{ color: "#777", marginTop: "10px" }}>Loading...</p>
              </div>
            ))
          : maincategoriesItem.map((category) => (
              <div key={category.id} className="category-item">
                <Link to={`/searchs/${category.slug}`}>
                  <img
                    src={category.image ? `${imageUrl}menu/${category.image}` : "https://via.placeholder.com/150"}
                    alt={category.title}
                    loading="lazy"
                    onLoad={() => setLoading(false)}
                  />
                  <div className="text-center">
                    <p className="text-white trunk">{category.title}</p>
                  </div>
                </Link>
              </div>
            ))}
      </Slider>

      {/* Skeleton animation */}
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 0.3; }
            50% { opacity: 0.7; }
            100% { opacity: 0.3; }
          }
        `}
      </style>
    </div>
  );
};

export default CategorySlider;
